import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateUpdateLookupOptionMutation, MutateUpdateLookupOptionMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateUpdateLookupOption($key: String!, $id: MongoID!, $record: JSON!) {
    lookups {
      update(key: $key, _id: $id, record: $record) {
        _id
      }
    }
  }
`)

export type UseMutateUpdateLookupOptionReturn = UseMutationResult<
MutateUpdateLookupOptionMutation,
unknown,
MutateUpdateLookupOptionMutationVariables
>

const useMutateUpdateLookupOption = (): UseMutateUpdateLookupOptionReturn => {
  return useGraphMutation(document)
}

export { useMutateUpdateLookupOption, document as mutateUpdateLookupOptionDocument }
